import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from './apis';
import Swal from 'sweetalert2';
import { RootState } from '../../domain/models/RootState';
import { createAsyncThunkApp } from '../hooks';

export const getLoanP2PKeyByID = createAsyncThunkApp<any, any>(
  'LoansP2P/KeyById',
  async (value: any, thunkAPI) => {
    try {
      const { auth }: RootState = thunkAPI.getState();
      const res: any = await API.getLoanP2PKeyByID(auth.token, value);
      // const res.data= simulandoRespuesta;
      return res.data;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hubo un error al cargar los datos del usuario',
        text: 'intenta de nuevo',
      });
      throw error;
    }
  }
);
